import { action, observable } from 'mobx';

class UiState {
  @observable public isReady: boolean = false;
  @observable public hasError: boolean = false;
  @observable
  public error = {
    title: '',
    message: '',
  };
  @observable
  public snackbar = {
    isActive: false,
    message: '',
    actionText: '',
    actionHandler: (_: React.MouseEvent<HTMLElement>) => {},
  };
  @observable public mode: number = 1; // 1:RoundMonitor, 2:OrganizationSetting

  @action
  public setReady(isReady: boolean): void {
    this.isReady = isReady;
  }

  @action
  public setError({ title, message }: { title: string; message: string }): void {
    this.hasError = true;
    this.error.title = title;
    this.error.message = message;
  }

  @action
  public clearError(): void {
    this.hasError = false;
    this.error.title = '';
    this.error.message = '';
  }

  @action
  public showSnackbar(
    message: string,
    timeout = 2750,
    actionText = '',
    actionHandler = (_: React.MouseEvent<HTMLElement>) => {},
  ): void {
    this.snackbar.isActive = true;
    this.snackbar.message = message;
    if (actionText) this.snackbar.actionText = actionText;
    if (actionHandler) this.snackbar.actionHandler = actionHandler;
    if (timeout) {
      setTimeout(() => {
        this.hideSnackbar();
      }, timeout);
    }
  }

  @action
  public hideSnackbar(): void {
    this.snackbar.isActive = false;
    this.snackbar.message = '';
    this.snackbar.actionText = '';
    this.snackbar.actionHandler = (_: React.MouseEvent<HTMLElement>) => {};
  }

  @action
  public toggleMode(): void {
    this.mode = this.mode == 1 ? 2 : 1;
  }
}

export default UiState;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/domain/store/UiState.ts